/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { IColumn } from 'types'

export const useTableModel = () => {
  const { t } = useTranslation()

  const handleDateTimeFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy HH:mm') : ''),
    [],
  )

  const handleDateFormat = useCallback(
    (cellValue: string) => (cellValue ? format(new Date(cellValue), 'dd-MM-yyyy') : ''),
    [],
  )

  const columns: IColumn[] = [
    {
      title: `${t('ledger.event-id')}`,
      field: 'event_id',
      order: false,
      width: '10%',
      format: (cellValue: string) => <span title={cellValue}>{cellValue?.slice(0, 8)}</span>,
    },
    {
      title: `${t('ledger.recorded-at')}`,
      field: 'recorded_at',
      order: true,
      width: '10%',
      format: handleDateTimeFormat,
    },
    {
      title: `${t('ledger.observed-at')}`,
      field: 'observed_at',
      order: true,
      width: '9%',
      format: handleDateFormat,
    },
    {
      title: `${t('ledger.observer')}`,
      field: 'observer',
      order: false,
      width: '11%',
    },
    {
      title: `${t('ledger.slo-id')}`,
      field: 'slo_id',
      order: true,
      width: '12%',
    },
    {
      title: `${t('ledger.evidence-task')}`,
      field: 'evidence_task',
      order: false,
      width: '16%',
    },
    {
      title: `${t('ledger.conditions')}`,
      field: 'conditions',
      order: false,
      width: '16%',
    },
    {
      title: `${t('ledger.observation')}`,
      field: 'observation',
      order: false,
      width: '16%',
    },
  ]

  return columns
}
